module.exports = __webpack_public_path__ + "images/12-07_962ed67b.jpg";